var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5L9.5 2L15.5 5L21.803 2.299C21.8791 2.26638 21.9621 2.25317 22.0445 2.26054C22.127 2.26792 22.2063 2.29565 22.2754 2.34124C22.3445 2.38684 22.4012 2.44888 22.4404 2.5218C22.4796 2.59471 22.5001 2.67622 22.5 2.759V19L15.5 22L9.5 19L3.197 21.701C3.12091 21.7336 3.03792 21.7468 2.95547 21.7395C2.87301 21.7321 2.79368 21.7044 2.72459 21.6588C2.6555 21.6132 2.59881 21.5511 2.55961 21.4782C2.52041 21.4053 2.49993 21.3238 2.5 21.241V5ZM16.5 19.395L20.5 17.681V5.033L16.5 6.747V19.395ZM14.5 19.264V6.736L10.5 4.736V17.264L14.5 19.264ZM8.5 17.253V4.605L4.5 6.319V18.967L8.5 17.253Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMapIcon);
export default __webpack_public_path__ + "static/media/navMapIcon.a414c9665e88b12022e7aa601a0fde04.svg";
export { ForwardRef as ReactComponent };